import React, { useState } from "react";
import styles from "./VoiceAssistant.module.scss";

const VoiceAssistant = () => {
  const [isListening, setIsListening] = useState(false);

  const handleClick = () => {
    setIsListening(!isListening);
    // TODO: Implement voice recognition logic
  };

  return (
    <div className={styles.voiceAssistantWrapper} onClick={handleClick}>
      <div className={`${styles.voiceOrb} ${isListening ? styles.listening : ''}`}>
        <div className={styles.orbCore}></div>
        <div className={styles.orbRing}></div>
        <div className={styles.orbRing2}></div>
      </div>
    </div>
  );
};

export default VoiceAssistant;
